const FIELD_REGEX = {
    email: /^((([^#<>()[\]\\.,;:\s@"]+(\.[^#<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$/,
    login: /^((603049[0-9]{10})|((([^#<>()[\]\\.,;:\s@"]+(\.[^#<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))))$/,
};

export function fieldValidator(fieldName, value) {
    if (fieldName) {
        return FIELD_REGEX[fieldName].test(value);
    }
    return false;
}

export function formValidator(formState) {
    let field = null;
    formState.formValid = true;
    Object.keys(formState).forEach(function (key) {
        if (key !== 'formValid') {
            field = formState[key];
            if ((field.value === null || field.value === undefined || field.value === '') && !field.mandatory) {
                field.valid = null;
            } else if (field.value) {
                field.valid = fieldValidator(key, field.value);
                // if form is invalid, we don't want to change its value but we still want to validate all the remining fields
                if (formState.formValid) {
                    formState.formValid = field.valid;
                }
            } else {
                field.valid = false;
                formState.formValid = false;
            }
            formState[key] = field;
        }
    });
    return formState;
}

export const isValidEmail = (value) => FIELD_REGEX.email.test(value);
